import type { WriteOp } from "../components/WriteOpsHint";

/**
 * Die Integrations-Ansicht ist read-only (D-GOV-25). Geaendert wird agent-first:
 * die CLI kommt beim Bootstrap ohnehin mit (D-COX-31), und ein Agent bedient sie.
 *
 * Die Schreib-Verben stehen unter ``integrations`` (D-COX-32, #283). Diese
 * Snippets nennen die real laufende Form; eine geschoente waere ein Kommando,
 * das nicht laeuft.
 *
 * **Kein ``AGENT``-Eintrag.** Diese Sektion ist laut §6.2 auch fuer einen reinen
 * Owner sichtbar, und der einzige gefuehrte Weg zum Anbinden einer Quelle ist
 * ``kw-integration-setup`` — ein Skill, der in keiner Distributionsliste steht
 * (weder ``packs/kw/base/pack.yaml`` noch ``_AUTHORING_SKILLS``/
 * ``_PACK_AUTHORING_SKILLS``): ihn hat nur, wer das kontextwerk-Repo selbst als
 * Workspace geoeffnet hat. Ihn hier zu nennen hiesse einem Owner einen Weg
 * anzubieten, den es fuer ihn nicht gibt (D-COX-31). Der reale Weg sind die
 * CLI-Verben unten; der Kanal bleibt fuer eine Fassade, die ein Owner hat.
 */
export const INTEGRATIONS_WRITE_OPS: WriteOp[] = [
  {
    channel: "CLI",
    label: "Katalog: was kann diese Instanz",
    snippet: "kontextwerk-cli integrations types",
  },
  {
    channel: "CLI",
    label: "Bindungen gegen Katalog + Secret-Store pruefen",
    snippet: "kontextwerk-cli integrations status --realm <realm_id>",
  },
  {
    channel: "CLI",
    label: "Quelle anlegen (Secret inline)",
    snippet:
      "kontextwerk-cli integrations source add --realm <realm_id> \\\n" +
      "  --type onedrive --name meine-ablage \\\n" +
      "  --adapter-config '{\"folder\":\"/Notizen\",\"client_id\":\"<app-id>\"}' \\\n" +
      "  --credentials '{\"refresh_token\":\"<token>\"}'",
  },
  {
    channel: "CLI",
    label: "Quelle abschalten / entfernen",
    snippet: "kontextwerk-cli integrations source remove --realm <realm_id> <name>",
  },
  {
    channel: "CLI",
    label: "Email-Kanal binden (braucht kw:realm-admin)",
    snippet: "kontextwerk-cli integrations channel email set-address --realm <realm_id> --token <address-token>",
  },
  {
    channel: "CLI",
    label: "Teams-Kanal binden (braucht kw:realm-admin)",
    snippet:
      "kontextwerk-cli integrations source login --type teams --tenant-id <tid> --client-id <cid>\n" +
      "kontextwerk-cli integrations channel teams set --realm <realm_id> --team-id <t> --channel-id <c> \\\n" +
      "  --refresh-token <token>",
  },
];
